import React, { useEffect, useMemo, useRef, useState } from 'react';
import Card from '../ResourceCard/Card';
import styled from 'styled-components';
import * as colors from '../../util/colors';

const deBounce = (cb,delay) =>{
    let timer;

    return function(...args){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            cb(...args)
        },delay);
    }
}

const ResourceCustomSliderWrapper = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
   overflow:hidden;
    position:relative;
    padding:0 48px;
    @media(max-width: 992px){
    padding:0px;
         &:before,&:after{
    transition: 0.3s ease opacity; 
                border: none;
                border-left: none;
                content: "";
                position: absolute;
                top: 29px;
                left:0;
                width: 20px;
                height: calc(100% - 77px);
                z-index: 1;
                pointer-events: none;
                // border-radius: 8px;
                background: linear-gradient(90deg, ${props => (props.overlayShadow ? props.overlayShadow : "#fff")} 0%, transparent 70%);
                
        }
                &:before{
                border-right: none;
                opacity:${(props)=>props.currentSlider > 0 ? 1 : 0};
                }
        &:after{
            left:unset;
            right:0;
            border-left: none;
            background: linear-gradient(270deg,  ${props => (props.overlayShadow ? props.overlayShadow : "#fff")} 0%, transparent 70%);
            opacity:${(props)=>props.currentSlider < props.slidesDevider.md.length - 1 ? 1 : 0};
            @media(max-width:767px){
            opacity:${(props)=>props.currentSlider < props.slidesDevider.sm.length - 1 ? 1 : 0};
            }
        }
    }
`;

const ResourceCustomSliderContainer = styled.div`
    display:flex;
    flex-direction: row;
    flex-wrap:nowrap;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    scrollbar-width: none;
    width:100%;
        padding: 30px 0;
    gap: 20px;

    &::-webkit-scrollbar {
    display: none;
    }
    @media(max-width: 992px){
        padding: 30px 40px;
        gap:10px;
        
    }
    @media(max-width:374px){
        padding: 30px 20px;
    }
    
`;


const Arrow = styled.button`
    position:absolute;
    top:50%;
    transform:translateY(-50%);
    width:44px;
    height:44px;
    border-radius: 50%;
    border: 1px solid transparent;
    background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 15.7138L12.6069 17.1069L6 10.5L12.6069 3.89307L14 5.28615L8.78695 10.5L14 15.7138Z" fill="%23006EAD"/></svg>');
    background-repeat:no-repeat;
    cursor:pointer;
    background-position: center;
    @media (max-width: 1024px){
            display:none;
        }
    &:hover{
    background-color: #EBEAEB;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 15.7138L12.6069 17.1069L6 10.5L12.6069 3.89307L14 5.28615L8.78695 10.5L14 15.7138Z" fill="%23004A85"/></svg>');
    }
`;

const PrevArrow = styled(Arrow)`
left:0;
margin-right: 4px;
`;
const NextArrow = styled(Arrow)`
right:0;
margin-left: 4px;
transform:translateY(-50%) rotate(180deg);
`;

const ResourceCustomSliderItems = styled.div`
flex-direction: row;
display:grid;
grid-template-rows:1fr;
grid-template-columns: repeat(${props => (props.slideByColumn ? props.slideByColumn : 3)}, 1fr);
width:100%;
scroll-snap-align: center;
padding:0 20px 0 10px;
gap: 20px;
 @media(max-width: 992px){
        padding:0;
        gap: 10px;
        grid-template-columns: repeat(${props => (props.slideByColumn ? props.slideByColumn : 2)}, 1fr);
          
 }
@media(max-width: 767px){
        grid-template-columns: repeat(${props => (props.slideByColumn ? props.slideByColumn : 1)}, 1fr);
 }
`;

const ResourceCustomSliderItem = styled.div`

`;

const DotsWrapper = styled.div`
display:flex;
justify-content:center;
`;

const DotButton = styled.button`
cursor:pointer;
background-color: #8C8C8C;
width: 8px;
    height: 8px;
    border-radius:50%;
    border:none;
    padding:0;
    margin:5px 7px;
&.dotActive{
background-color: #006EAD;
    box-shadow: 0px 0px 6px 0px #006EAD;
}
`;

const ResourceCustomSlider = ({items=[], sliderId,dataDesignModule, className, slideBy={lg:3,md:2,sm:1}, nav={lg:true,md:false,sm:false}, dots=true, overlayShadowType="white" || "cloud"}) =>{
    const [currentSlider, setCurrentSlider] = useState(0);
    // const [slidesDevider, setSlideDevider] = useState({lg:[],md:[],sm:[]})

    // useEffect(()=>{
    //     const deviderData = (arr, num) => {
    //         let res = [];
    //         let referenceArr = [...arr];
    //         let blankCardNum = 0;
    //         blankCardNum = Math.ceil(arr.length / num) * num - arr.length
            
    //         if(blankCardNum > 0){
    //             for (let b = 0; b < blankCardNum; b++) {
    //                 referenceArr.push({blank:true})
    //             }
    //         }

    //         for (let i = 0; i < referenceArr.length; i += num) {
    //         res.push(referenceArr.slice(i, i + num));
    //         }
    //         return res;
    //     }
    //     if(items.length === 0) return;
    //     setSlideDevider({
    //         lg:deviderData(items,slideBy.lg),
    //         md:deviderData(items,slideBy.md),
    //         sm:deviderData(items,slideBy.sm),
    //     })
    // },[items])

    const slidesDevider = useMemo(() => {
        const deviderData = (arr, num) => {
            let res = [];
            let referenceArr = [...arr];
            let blankCardNum = Math.ceil(arr.length / num) * num - arr.length;

            if (blankCardNum > 0) {
            for (let b = 0; b < blankCardNum; b++) {
                referenceArr.push({ blank: true });
            }
            }

            for (let i = 0; i < referenceArr.length; i += num) {
            res.push(referenceArr.slice(i, i + num));
            }

            return res;
        };

        if (items.length === 0) return { lg: [], md: [], sm: [] };

        return {
            lg: deviderData(items, slideBy.lg),
            md: deviderData(items, slideBy.md),
            sm: deviderData(items, slideBy.sm),
        };
    }, [items]);


    const scrollContainerRef = useRef(null);

    const nextSlide = () =>{
        let windowSize = window.innerWidth;
        if(windowSize < 767 && slidesDevider.sm.length - 1 > currentSlider ) setCurrentSlider((prev)=>prev+1)
        if(windowSize < 992 && slidesDevider.md.length - 1 > currentSlider ) setCurrentSlider((prev)=>prev+1)
        if( slidesDevider.lg.length - 1 > currentSlider ) setCurrentSlider((prev)=>prev+1)
         if (scrollContainerRef.current) {
        const container = scrollContainerRef.current;
         const slides = container.querySelectorAll('[class*="ResourceCustomSliderItems"]');
        // const scrollAmount = container.offsetWidth; // or container.clientWidth
         const targetPrevSlide = slides[currentSlider + 1].offsetLeft;
        container.scrollTo({ left: targetPrevSlide, behavior: 'smooth' });
  }
    }
    const prevSlide = () =>{
        currentSlider > 0 && setCurrentSlider((prev)=>prev-1)
         if (scrollContainerRef.current) {
    const container = scrollContainerRef.current;
    const slides = container.querySelectorAll('[class*="ResourceCustomSliderItems"]');
    // const scrollAmount = container.offsetWidth;
    // container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    const targetPrevSlide = slides[currentSlider - 1].offsetLeft;
        container.scrollTo({ left: targetPrevSlide, behavior: 'smooth' });
  }
    }

   const dotSlide = (index) => {
    setCurrentSlider(index);

    if (scrollContainerRef.current) {
        const container = scrollContainerRef.current;

        const slides = container.querySelectorAll('[class*="ResourceCustomSliderItems"]');
        if (slides && slides[index]) {
            const targetSlide = slides[index];
            const offsetLeft = targetSlide.offsetLeft;

            container.scrollTo({ left: offsetLeft, behavior: 'smooth' });
        }
    }
};

useEffect(()=>{
   const handleNav = () => {
        if (!scrollContainerRef.current) return;

        const container = scrollContainerRef.current;
        const slides = container.querySelectorAll('[class*="ResourceCustomSliderItems"]');

        for (let index = 0; index < slides.length; index++) {
            const rect = slides[index].getBoundingClientRect();

            if (rect.x >= 0) {
                // slides.forEach((slide, i) => {
                //     slide.style.setProperty('--overlayOpacity', i === index ? '1' : '0');
                // });
            setCurrentSlider(index);


            break;
            }
        }
    };

    const handleWheel = (e) => {
    const absX = Math.abs(e.deltaX);
    const absY = Math.abs(e.deltaY);


    if (absX > absY) { 
        // Only prevent default if the scroll is mostly horizontal 
        e.preventDefault(); 
    }

    // If both directions are significant → it's diagonal
    if (absX > 0 && absY > 0) {
        e.preventDefault();
        return;
    }

    // Otherwise allow normal scroll
    };

    const deBounceHandleNav = deBounce(handleNav,300);
    // const deBounceHanldeSwiping = deBounce(hanldeSwiping,300);
    scrollContainerRef.current.addEventListener("touchmove",deBounceHandleNav)
    // scrollContainerRef.current.addEventListener("touchstart",deBounceHanldeSwiping)
    scrollContainerRef.current.addEventListener("wheel",handleWheel,{passive:false})
    return ()=>{
        if(scrollContainerRef.current){

            scrollContainerRef.current.removeEventListener("touchmove",deBounceHandleNav)
            // scrollContainerRef.current.addEventListener("touchstart",deBounceHanldeSwiping)
            scrollContainerRef.current.removeEventListener("wheel",handleWheel)
        }
    }
},[])

// useEffect(()=>{
//      if (!scrollContainerRef.current) return;
//     if(window.innerWidth < 992){
//         const spaceRemainCard =  scrollContainerRef.current.querySelectorAll('[class*="ResourceCustomSliderItems"].NotActive')[0].offsetWidth
//         console.log("spaceRemainCard",spaceRemainCard);
        
//     }
// },[])

    return (<>
    <ResourceCustomSliderWrapper overlayShadow={colors[overlayShadowType]} currentSlider={currentSlider} slidesDevider={slidesDevider} id={sliderId} className={className} data-design-module={dataDesignModule}>
        {
            currentSlider > 0 ?  <WindowResizeRender 
            lg={()=>nav.lg ? <PrevArrow onClick={prevSlide} /> : <></>}
            md={()=>nav.md ? <PrevArrow onClick={prevSlide} /> : <></>}
            sm={()=>nav.sm ? <PrevArrow onClick={prevSlide} /> : <></>}
          /> : null
        }
         
        <ResourceCustomSliderContainer ref={scrollContainerRef}>
        <WindowResizeRender
            lg={()=> {
                return slidesDevider.lg.map((eachSlide,index) => {
                    return <ResourceCustomSliderItems className={currentSlider === index ? "CardActive" : "NotActive"} slideByColumn={slideBy.lg} key={`item-${index}`}>
                   { eachSlide.map((eachCard,index)=>{
                        return <ResourceCustomSliderItem className="itemCard" key={`eachCard-${index}`}>
                        <Card {...eachCard} rowKey={1} colKey={index} rowTier={3} isButtonDisable={eachCard.isButtonDisable}  />
                        </ResourceCustomSliderItem>
                           
                    })
                }
                     </ResourceCustomSliderItems>
                })
            }}
            md={()=> {
                return slidesDevider.md.map((eachSlide,index) => {
                    return <ResourceCustomSliderItems className={currentSlider === index ? "CardActive" : "NotActive"} slideByColumn={slideBy.md} key={`item-${index}`}>
                   { eachSlide.map((eachCard,index)=>{
                        return <ResourceCustomSliderItem className="itemCard" key={`eachCard-${index}`}>
                        <Card {...eachCard} rowKey={1} colKey={index} rowTier={3} isButtonDisable={eachCard.isButtonDisable}  />
                        </ResourceCustomSliderItem>
                           
                    })
                }
                     </ResourceCustomSliderItems>
                })
            }}
            sm={()=> {
                return slidesDevider.sm.map((eachSlide,index) => {
                    return <ResourceCustomSliderItems className={currentSlider === index ? "CardActive" : "NotActive"} slideByColumn={slideBy.sm} key={`item-${index}`}>
                   { eachSlide.map((eachCard,index)=>{
                        return <ResourceCustomSliderItem className="itemCard" key={`eachCard-${index}`}>
                        <Card {...eachCard} rowKey={1} colKey={index} rowTier={3} isButtonDisable={eachCard.isButtonDisable}  />
                        </ResourceCustomSliderItem>
                           
                    })
                }
                     </ResourceCustomSliderItems>
                })
            }}
        />
        <WindowResizeRender 
            lg={()=>nav.lg && currentSlider < slidesDevider.lg.length - 1 ? <NextArrow onClick={nextSlide} /> : <></>}
            md={()=>nav.md && currentSlider < slidesDevider.lg.length - 1 ? <NextArrow onClick={nextSlide} /> : <></>}
            sm={()=>nav.sm && currentSlider < slidesDevider.lg.length - 1 ? <NextArrow onClick={nextSlide} /> : <></>}
          />
        </ResourceCustomSliderContainer>
        {dots ?
        <DotsWrapper>
            <WindowResizeRender
            lg={()=> {
                return slidesDevider.lg.length > 1 ? slidesDevider.lg.map((eachSlide,index) => {
                    return <DotButton className={currentSlider === index ? "dotActive" :""} onClick={()=>{dotSlide(index)}} key={`dot-${index}`}>
                     </DotButton>
                }) : null;
            }}
            md={()=> {
                return slidesDevider.md.length > 1 ? slidesDevider.md.map((eachSlide,index) => {
                    return <DotButton className={currentSlider === index ? "dotActive" :""} onClick={()=>{dotSlide(index)}} key={`dot-${index}`}>
                  
                     </DotButton>
                }): null;
            }}
            sm={()=> {
                return slidesDevider.sm.length > 1 ? slidesDevider.sm.map((eachSlide,index) => {
                    return <DotButton className={currentSlider === index ? "dotActive" :""} onClick={()=>{dotSlide(index)}} key={`dot-${index}`}>
                     </DotButton>
                }): null;
            }}
        />
        </DotsWrapper>:null
        }
    </ResourceCustomSliderWrapper>
    </>)
}

const WindowResizeRender = ({ lg, md ,sm}) =>{
    const [windowWidth, setWindowWidth] =  useState(null);

    
    useEffect(()=>{
         if (typeof window === 'undefined') return;
        const handleResize = () => setWindowWidth(window.innerWidth);
        handleResize();
        const DebounceHandleResize = deBounce(handleResize,500)
        window.addEventListener("resize", DebounceHandleResize);

        return ()=> window.removeEventListener("resize", DebounceHandleResize);


    },[])
    // if (windowWidth === null) return null;
    if(windowWidth < 767){
        return sm();
    }
    if(windowWidth < 992){
        return md();
    }
    return lg();
}


export default ResourceCustomSlider;